import React from "react";
import { Grid, Typography, Stack } from "@mui/material";
import { Link as DomLink } from "react-router-dom";

const BraceletsTab = ({ links }) => {
  return (
    <Grid container>
      <Grid item xs={3}>
        <Stack direction="column" className="navbar-stack">
          <Typography className="navbar-text">Shop by Metal Color</Typography>
          {links.BraceletsLinks.MetalColor.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/Bracelets",
                state: {
                  Material: link.materials,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/Bracelets") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">Additional Info</Typography>
        <Stack direction={"column"} className="navbar-stack">
          {links.AdditionalInfo.map((link, index) => (
            <DomLink key={index} to={{ pathname: link.path }}>
              {link.label}
            </DomLink>
          ))}
        </Stack>
        <Typography className="navbar-text">Outlet Store</Typography>
        <Stack direction="column" className="navbar-stack">
          {links.OutletStore.map((link, index) => (
            <a key={index} href={link.path} target="_blank" rel="noreferrer">
              {link.label}
            </a>
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default BraceletsTab;
